<script lang="ts" setup>
import useMatestoreStore from '@/store/matestoreStore';
import { useRouter } from 'vue-router';
import MicroIcon from '@/components/MicroIcon.vue';
import { computed } from 'vue';
import HistoryTabName from '@/components/tabs/HistoryTabName.vue';
import { BRAND_MAP } from '@/enums';
import useGlobalStore from '@/store/globalStore';
import { NIconSVG } from '@nio-fe/icon';
interface HistoryTabItemProps {
  name: string;
  route: any;
  icon: string;
  closeable: boolean;
  active: boolean;
  tabIndex: number | string;
}
const router = useRouter();
const emit = defineEmits(['click']);
const props = defineProps<HistoryTabItemProps>();
const matestoreStore = useMatestoreStore();
const handleClick = () => {
  emit('click');
  if (props.active) {
    return;
  }
  window.location.hash = `#${props.route.fullPath.split('#')[1]}`;
};
const brandQueryReg = new RegExp(`brand=(${Object.keys(BRAND_MAP).join('|')})`);
const globalStore = useGlobalStore();
const shouldShowIcon = computed(() => {
  if (globalStore.getAvailableBrands().length < 2) {
    return true;
  }
  return (
    props.icon &&
    props.route.fullPath &&
    !brandQueryReg.test(props.route.fullPath)
  );
});
const handleClose = (e) => {
  matestoreStore.removeTabItem(props.route.microName, Number(props.tabIndex));
  e.stopPropagation();
};
</script>

<template>
  <div
    :class="{ 'history-tab-item': true, 'history-tab-item--active': active }"
    :id="`mateHistoryTab${tabIndex}`"
    @click="handleClick"
  >
    <MicroIcon v-if="shouldShowIcon" class="icon" :icon="icon" :size="16" />
    <label :title="route?.fullPath"
      ><history-tab-name :route="route" :name="name"
    /></label>
    <n-button
      v-show="closeable"
      icon="close"
      type="text"
      size="mini"
      kind="neutral"
      @click="handleClose"
    />
    <span
      class="history-tab-item__radius-decoration history-tab-item__radius-decoration--left"
    ></span>
    <span
      class="history-tab-item__radius-decoration history-tab-item__radius-decoration--right"
    ></span>
  </div>
</template>

<style lang="scss" scoped>
.history-tab-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 8px 8px 0px 0px;
  padding: 8px 12px;
  height: 38px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
  > label {
    margin: 0 6px;
    font-size: 14px;
    line-height: 22px;
    color: #242629;
    display: block;
    cursor: pointer;
    white-space: nowrap;
  }
  .icon {
    display: block;
    color: #178ca6;
    margin: 3px;
  }

  &--active {
    background: #fff;
    .history-tab-item__radius-decoration {
      display: block;
    }
  }

  &__radius-decoration {
    display: none;
    width: 8px;
    height: 8px;
    background: #fff;
    position: absolute;
    bottom: 0;
    overflow: hidden;
    &:after {
      position: absolute;
      width: 16px;
      height: 16px;
      background: #f4f5f7;
      content: '';
      border-radius: 8px;
      bottom: 0;
    }

    &--left {
      left: -8px;
      &:after {
        left: -8px;
      }
    }
    &--right {
      right: -8px;
      &:after {
        right: -8px;
      }
    }
  }
}
</style>
